import { Alert, AlertIcon, AlertTitle, Button } from '@chakra-ui/react'
import type { AxiosError } from 'axios'
import type { Discount } from 'BrokerTsLib/src/dtos'
import type { DiscountBase } from 'BrokerTsLib/src/dtos/StepBase'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { useContext, useEffect } from 'react'

import { Refresh } from '@/icons'

import { useGetInsuranceParamsDiscounts } from '../../hooks/useInsuranceParams'
import { insuranceParamsContext } from '../../layouts/Wizard'

export const BusinessDiscounts = ({ onDiscountsLoaded }: { onDiscountsLoaded: () => void }) => {
  const { insuranceParamsId: paramsId } = useContext(insuranceParamsContext)!
  const { setValue } = useFormContext<DiscountBase>()

  const { data, refetch, isLoading, isFetching, isSuccess, isError, error } = useGetInsuranceParamsDiscounts(paramsId!, {
    enabled: !!paramsId,
  })

  useEffect(() => {
    if (isSuccess && data?.data) {
      const iDisc = data.data ?? []
      const flat = iDisc.reduce((current: Discount[], insurerDiscounts) => [...current, ...insurerDiscounts.discounts ?? []], []) ?? []
      setValue('discounts', flat)
      onDiscountsLoaded()
    }
  }, [data, isSuccess])

  useEffect(() => {
    if (isError) {
      const e = error as AxiosError
      if (e?.code === 'ECONNABORTED' || e?.code === 'ERR_NETWORK')
        refetch()
      onDiscountsLoaded()
    }
  }, [isError, error])

  const loading = isLoading || isFetching

  // const insurersDiscounts = data?.data?.map(x => ({ ...x, discounts: x.discounts?.filter(d => d.editK1) ?? [] })) ?? []
  // const anyDiscount = insurersDiscounts.findIndex(x => x.discounts.length > 0) >= 0

  return (
    <>
      {/* 
      {loading
        && <Loading large={true} />}
      {isSuccess && <>
        {!loading && ((insurersDiscounts ?? []).length === 0 || !anyDiscount)
          && <Text textAlign='center'>Žádné slevy nejsou k dispozici</Text>}

        {!loading && (insurersDiscounts ?? []).length > 0 && anyDiscount &&
          <BusinessDiscountsWrapper>
            {insurersDiscounts.map((insurerDiscounts) =>
              insurerDiscounts.discounts.length > 0 && <BusinessCompanyDiscount key={insurerDiscounts.insurerId} {...insurerDiscounts} />
            )}
          </BusinessDiscountsWrapper>
        }
      </>} */}

      {!loading && isError && <Alert status='error'>
        <AlertIcon />
        <AlertTitle>Nepodařilo se načíst slevy.</AlertTitle>
        <Button onClick={() => refetch()} ml='auto'><Refresh /> Zkusit znovu</Button>
      </Alert>}
    </>
  )
}
